import React from 'react';
import './TripIncludedExcluded.css';

function TripIncludedExcluded({ tour }) {
  return (
    <section className="trip-included-excluded">
      <div className="trip-included-excluded-container">
        <div className="trip-included-section">
          <h2 className="trip-section-title trip-included-title">
            <span className="trip-included-icon">✓</span>
            What's Included
          </h2>
          {tour.included && tour.included.length > 0 ? (
            <ul className="trip-included-list">
              {tour.included.map((item, index) => (
                <li key={index} className="trip-included-item">
                  {item}
                </li>
              ))}
            </ul>
          ) : (
            <p className="trip-no-data">No information available</p>
          )}
        </div>

        <div className="trip-excluded-section">
          <h2 className="trip-section-title trip-excluded-title">
            <span className="trip-excluded-icon">✗</span>
            What's Not Included
          </h2>
          {tour.excluded && tour.excluded.length > 0 ? (
            <ul className="trip-excluded-list">
              {tour.excluded.map((item, index) => (
                <li key={index} className="trip-excluded-item">
                  {item}
                </li>
              ))}
            </ul>
          ) : (
            <p className="trip-no-data">No information available</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default TripIncludedExcluded;

